export default "__VITE_ASSET__0axOvsWj__"